import { Navigate, Route, Routes } from "react-router-dom";
import { Loader2 } from "lucide-react";
import AppShell from "@/components/layout/AppShell";
import { ErrorState } from "@/components/common/States";
import { useWorkspace } from "@/context/WorkspaceContext";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Companies from "@/pages/Companies";
import Stage1 from "@/pages/Stage1";
import Billing from "@/pages/Billing";
import Email from "@/pages/Email";
import PaymentSuccess from "@/pages/PaymentSuccess";

import CompanyDetail from "@/pages/CompanyDetail";
import Contacts from "@/pages/Contacts";
import Opportunities from "@/pages/Opportunities";
import Tasks from "@/pages/Tasks";
import Products from "@/pages/Products";
import Integrations from "@/pages/Integrations";
import Settings from "@/pages/Settings";
import PlannedModule from "@/pages/PlannedModule";
import Research from "@/pages/Research";
import CampaignDetail from "@/pages/CampaignDetail";

export default function WorkspaceGate() {
  const { loading, error, memberships, reload } = useWorkspace();
  if (loading) return <div className="grid min-h-screen place-items-center" data-testid="workspace-loading"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>;
  if (error) return <div className="mx-auto max-w-xl pt-24"><ErrorState message={error} onRetry={() => reload()} testid="workspace-error" /></div>;
  if (!memberships.length) return <Onboarding />;
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Dashboard />} />
        <Route path="research" element={<Research />} />
        <Route path="research/campaigns/:id" element={<CampaignDetail />} />
        <Route path="opportunities" element={<Opportunities />} />
        <Route path="stage-1" element={<Stage1 />} />
        <Route path="companies" element={<Companies />} />
        <Route path="companies/:id" element={<CompanyDetail />} />
        <Route path="contacts" element={<Contacts />} />
        <Route path="email" element={<Email />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="knowledge" element={<Products />} />
        <Route path="integrations" element={<Integrations />} />
        <Route path="settings" element={<Settings />} />
        <Route path="billing" element={<Billing />} />
        <Route path="payment/success" element={<PaymentSuccess />} />
        <Route path="onboarding" element={<Onboarding embedded />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
